import {socialClubActionTypes} from './club.actionTypes';
const initialState = {
  markets: [],
  clubList: [],
  clubLive: [],
  clubClosed: [],
  clubLoading: false,
  liveLoading: false,
  closedLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case socialClubActionTypes.SET_CLUB_EVENT_DATA_LOAD: {
      return {...state, ld_Club_EventData: true};
    }
    case socialClubActionTypes.SET_CLUB_EVENT_DATA: {
      return {
        ...state,
        ld_Club_EventData: false,
        clubEventDetails: action.payload?.data,
        er_Club_eventData: null,
      };
    }
    case socialClubActionTypes.SET_CLUB_EVENT_DATA_FAIL: {
      return {
        ...state,
        ld_Club_EventData: false,
        er_Club_eventData: action.error,
      };
    }
    case socialClubActionTypes.FETCH_CLUB_MARKET_REQUEST: {
      return {
        ...state,
        ld_Club_EventData: false,
        er_Club_eventData: action.error,
      };
    }
    case socialClubActionTypes.FETCH_CLUB_MARKET_SUCCESS: {
      return {
        ...state,
        markets: action.payload,
      };
    }
    case socialClubActionTypes.SET_CLUB_LIST_REQUEST: {
      return {
        ...state,
        clubLoading: true,
      };
    }
    case socialClubActionTypes.SET_CLUB_LIVE_DATA_REQUEST: {
      return {
        ...state,
        liveLoading: true,
      };
    }
    case socialClubActionTypes.SET_CLUB_CLOSED_DATA_REQUEST: {
      return {
        ...state,
        closedLoading: true,
      };
    }
    case socialClubActionTypes.SET_CLUB_LIST: {
      return {
        ...state,
        clubLoading: false,
        clubList: action.payload?.clubs,
      };
    }
    case socialClubActionTypes.SET_CLUB_LIVE_DATA: {
      return {
        ...state,
        liveLoading: false,
        clubLive: action.payload,
      };
    }
    case socialClubActionTypes.SET_CLUB_CLOSED_DATA: {
      return {
        ...state,
        closedLoading: false,
        clubClosed: action.payload,
      };
    }
    case socialClubActionTypes.SET_CLUB_LIST_FAIL: {
      return {
        ...state,
        clubLoading: false,
        clubListErrors: action.payload,
      };
    }
    case socialClubActionTypes.SET_CLUB_LIVE_DATA_FAIL: {
      return {
        ...state,
        liveLoading: false,
        clubLiveErrors: action.payload,
      };
    }
    case socialClubActionTypes.SET_CLUB_CLOSED_DATA_FAIL: {
      return {
        ...state,
        closedLoading: false,
        clubClosedErrors: action.payload,
      };
    }
    case socialClubActionTypes.FETCH_CLUB_MARKET_ERROR: {
      return {
        ...state,
        markets: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export {reducer as socialClubReducer};
